export default {
  oilFlowRate: '',
  coolingPower: '',
  oilPressure: '',
  aboveSeaLevel: '',
  oilInletTemperature: '',
  airInletTemperature: '',
  specificCoolingCapacity: '',
  oil: '',
  pumpType: '',
  tankCapacity: '',
  endTemperature: '',
  startingTemperature: '',
  heatingTime: '',
}

// efficiency: '',
// motorPower: '',
// medium: '',
